import { Injectable } from "@nestjs/common";
import { Repository } from "typeorm";
import { PoBomEntity } from "../entittes/po-bom.entity";
import { InjectRepository } from "@nestjs/typeorm";
import { BomEntity } from "../entittes/bom-entity";
import { ZFactorsBomEntity } from "../entittes/z-factors-bom.entity";
import { ZFactorsEntity } from "../entittes/z-factors.entity";
import { BomProposalDataModel, BomProposalReq } from "@project-management-system/shared-models";
import { StyleComboEntity } from "../entittes/style-combo-entity";
import { ItemAttributesEntity } from "../entittes/item-attributes.entity";
import { SizehtMatrixEntity } from "../entittes/size-ht-matrix-entity";
import { HMStyleEntity } from "../entittes/hm-style-entity";
import { BackingPaperV2 } from "../../backing-paper-v2/backing-paper-v2-entity";
import { CartonBoxEntity } from "../entittes/carton_box_entity";
import { StyleEntity } from "../entittes/style-entity";
import { TissuePaperEntity } from "../entittes/tissue-paper.entity";
import { ZipperEntity } from "../../zipper/entity/zipper-entity";
import { PPMDataEntity } from "../../dpom/entites/ppm.entity";

@Injectable()
export class PoBomRepo extends Repository<PoBomEntity> {
    constructor(@InjectRepository(PoBomEntity) private poBomRepo: Repository<PoBomEntity>
    ) {
        super(poBomRepo.target, poBomRepo.manager, poBomRepo.queryRunner);
    }

    async getProposalsData(req: BomProposalReq): Promise<BomProposalDataModel[]> {
        const query = this.createQueryBuilder('pb')
            .select(`pb.id,pb.po_qty as poQty,pb.bom_qty as bomQty,pb.consumption,pb.wastage,pb.moq,b.description,b.im_code as imCode,
            b.use,pb.ip_uom as uom,d.style_number as styleNumber,d.color_desc as color,d.destination_country as destination,d.geo_code as geoCode,d.plant,
            d.planning_season_code as season,d.planning_season_year as year,d.size_description as size,SUBSTRING(d.bom_item, 1, 4) as itemNo,
            b.item_id as itemId,d.po_number as poNumber,d.gender_age_desc as gender, SUBSTRING(d.ogac, 1, 10) as ogacDate,
            TRIM(LEADING '0' FROM d.ship_to_customer_no) as shipToNumber, b.sequence,ia.attribute,ia.attribute_value as attributeValue,st.combination,st.item_color as itemColor,d.po_and_line as poAndLine,pb.dpom_id as dpomId`)
            .leftJoin(PPMDataEntity, 'd', 'd.id = pb.dpom_id')
            .leftJoin(BomEntity, 'b', 'b.id = pb.bom_id and pb.bom_id is not null')
            .leftJoin(ItemAttributesEntity, 'ia', 'ia.item_id=b.item_id')
            .leftJoin(StyleComboEntity, "st", "st.bom_id=b.id")
            .where(`d.po_and_line IN (:...poLine)`, { poLine: req.poLine })
            .andWhere(`b.item_id IN (:...itemId)`, { itemId: req.itemId })
            .andWhere(`pb.bom_id is not null`)
            .andWhere(`d.file_id = ${req.fileId}`)
            .orderBy(`b.sequence`)
        const rawData = await query.getRawMany()
        const mappedData: BomProposalDataModel[] = rawData.map(item => {
            return new BomProposalDataModel({
                id: item.id,
                poQty: item.poQty,
                bomQty: item.bomQty,
                consumption: item.consumption,
                wastage: item.wastage,
                moq: item.moq,
                description: item.description,
                imCode: item.imCode,
                use: item.use,
                styleNumber: item.styleNumber,
                color: item.color,
                destination: item.destination,
                geoCode: item.geoCode,
                plant: item.plant,
                season: item.season,
                year: item.year,
                size: item.size,
                itemColor: item.itemColor,
                itemNo: item.itemNo,
                itemId: item.itemId,
                gender: item.gender,
                poNumber: item.poNumber,
                ogacDate: item.ogacDate,
                shipToNumber: item.shipToNumber,
                attribute: item.attribute,
                attributeValue: item.attributeValue,
                sequence: item.sequence,
                uom: item.uom,
                combination: item.combination,
                poAndLine: item.poAndLine,
                dpomId: item.dpomId
            });
        });

        return mappedData;
    }

    async getZfactorsData(req: BomProposalReq): Promise<BomProposalDataModel[]> {
        const query = this.createQueryBuilder('pb')
            .select(`pb.id,pb.po_qty as poQty,pb.bom_qty as bomQty,pb.consumption,pb.wastage,pb.moq,
            d.style_number as styleNumber,d.color_desc as color,d.destination_country as destination,d.geo_code as geoCode,d.plant,d.planning_season_code as season,d.planning_season_year as year,d.size_description as size,SUBSTRING(d.bom_item, 1, 4) as itemNo,z.item_id as itemId,pb.zfactor_bom_id as zfactorBomId,zb.im_code as zbImCode,zb.item_name as zbItemName,zb.description,d.po_number as poNumber,d.gender_age_desc as gender, SUBSTRING(d.ogac, 1, 10) as ogacDate, SUBSTRING(d.ogac, 1, 10) as ogacDate,TRIM(LEADING '0' FROM d.ship_to_customer_no) as shipToNumber,zb.sequence,d.po_and_line as poAndLine,zb.id as zFactorBId`)
            .leftJoin(PPMDataEntity, 'd', 'd.id = pb.dpom_id')
            .leftJoin(ZFactorsBomEntity, 'zb', 'zb.id = pb.zfactor_bom_id and pb.zfactor_bom_id is not null')
            .leftJoin(ZFactorsEntity, 'z', 'z.id = zb.zfactor_id ')
            .where(`d.po_and_line IN (:...poLine)`, { poLine: req.poLine })
            .andWhere(`z.item_id IN (:...itemId)`, { itemId: req.itemId })
            .andWhere(`pb.zfactor_bom_id is not null`)
            .andWhere(`d.file_id = ${req.fileId}`)
        const rawData = await query.getRawMany()
        const mappedData: BomProposalDataModel[] = rawData.map(item => {
            return new BomProposalDataModel({
                id: item.id,
                poQty: item.poQty,
                bomQty: item.bomQty,
                consumption: item.consumption,
                wastage: item.wastage,
                moq: item.moq,
                description: item.description,
                imCode: item.zbImCode,
                use: item.use,
                styleNumber: item.styleNumber,
                color: item.color,
                destination: item.destination,
                geoCode: item.geoCode,
                plant: item.plant,
                season: item.season,
                year: item.year,
                size: item.size,
                itemNo: item.itemNo,
                itemId: item.itemId,
                gender: item.gender,
                poNumber: item.poNumber,
                ogacDate: item.ogacDate,
                shipToNumber: item.shipToNumber,
                sequence: item.sequence,
                poAndLine: item.poAndLine,
                zFactorBomId: item.zFactorBId
            });
        });

        return mappedData;
    }



    async getProposalsDataForButton(req: BomProposalReq): Promise<BomProposalDataModel[]> {
        const query = this.createQueryBuilder('pb')
            .select(`pb.id,pb.po_qty as poQty,pb.bom_qty as bomQty,pb.consumption,pb.wastage,pb.moq,b.description,b.im_code as imCode,b.use,
            d.style_number as styleNumber,d.color_desc as color,d.destination_country as destination,d.geo_code as geoCode,d.plant,d.planning_season_code as season,d.planning_season_year as year,d.size_description as size,SUBSTRING(d.bom_item, 1, 4) as itemNo,b.item_id as itemId,d.po_number as poNumber,d.gender_age_desc as gender,st.combination,st.primary_color as primaryColor,st.secondary_color as secondaryColor,st.item_color as itemColor,product_code as productCode,ia.attribute,ia.attribute_value as attributeValue,st.combination,b.qty as bBomQty,DATE_FORMAT(d.ogac, '%d-%b') as ogacDate, op_uom as opUom,d.po_and_line as poAndLine,pb.bom_id as bomId,b.vendor_name as vendorName,b.order_form AS orderForm`)
            // SUBSTRING(d.ogac, 1, 7) as ogacDate , 
            .leftJoin(PPMDataEntity, 'd', 'd.id = pb.dpom_id')
            .leftJoin(BomEntity, 'b', 'b.id = pb.bom_id and pb.bom_id is not null')
            .leftJoin(StyleComboEntity, 'st', 'st.bom_id = pb.bom_id and st.combination = RIGHT(d.product_code, 3)')
            .leftJoin(ItemAttributesEntity, 'ia', 'ia.item_id=b.item_id')
            .where(`d.po_and_line IN (:...poLine)`, { poLine: req.poLine })
            .andWhere(`b.item_id IN (:...itemId)`, { itemId: req.itemId })
            .andWhere(`pb.bom_id is not null`)
            .andWhere(`d.file_id = ${req.fileId}`)

        const rawData = await query.getRawMany()
        const mappedData: BomProposalDataModel[] = rawData.map(item => {
            return new BomProposalDataModel({
                id: item.id,
                poQty: item.poQty,
                bomQty: item.bomQty,
                consumption: item.consumption,
                wastage: item.wastage,
                moq: item.moq,
                description: item.description,
                imCode: item.imCode,
                use: item.use,
                styleNumber: item.styleNumber,
                color: item.color,
                destination: item.destination,
                geoCode: item.geoCode,
                plant: item.plant,
                season: item.season,
                year: item.year,
                size: item.size,
                itemNo: item.itemNo,
                itemId: item.itemId,
                gender: item.gender,
                poNumber: item.poNumber,
                combination: item.combination,
                primaryColor: item.primaryColor,
                secondaryColor: item.secondaryColor,
                itemColor: item.itemColor,
                productCode: item.productCode,
                attribute: item.attribute,
                attributeValue: item.attributeValue,
                bQty: item.bBomQty,
                ogacDate: item.ogacDate,
                opUom: item.opUom,
                poAndLine: item.poAndLine,
                bomId: item.bomId,
                vendorName : item.vendorName,
                orderForm : item.orderForm,

            });
        });
        return mappedData;
    }

    async getProposalsDataForElastic(req: BomProposalReq): Promise<BomProposalDataModel[]> {
        const query = this.createQueryBuilder('pb')
            .select(`pb.id,pb.po_qty as poQty,pb.bom_qty as bomQty,pb.consumption,pb.wastage,pb.moq,b.description,b.im_code as imCode,b.use,
            d.style_number as styleNumber,d.color_desc as color,d.destination_country as destination,d.geo_code as geoCode,d.plant,d.planning_season_code as season,d.planning_season_year as year,d.size_description as size,SUBSTRING(d.bom_item, 1, 4) as itemNo,b.item_id as itemId,d.po_number as poNumber,d.gender_age_desc as gender,st.combination,st.primary_color as primaryColor,st.secondary_color as secondaryColor,st.item_color as itemColor,product_code as productCode,b.id AS bomId, st.id AS stcomboId ,size_qty AS totalGarmentQty,pb.op_uom as uom,ia.attribute_value as attributeValue`)
            .leftJoin(PPMDataEntity, 'd', 'd.id = pb.dpom_id')
            .leftJoin(BomEntity, 'b', 'b.id = pb.bom_id and pb.bom_id is not null')
            .leftJoin(StyleComboEntity, 'st', 'st.bom_id = b.id and  st.combination = RIGHT(d.product_code, 3)')
            .leftJoin(ItemAttributesEntity, 'ia', 'ia.item_id = b.item_id and ia.im_code = b.im_code and ia.style = d.style_number')
            .where(`d.po_and_line IN (:...poLine)`, { poLine: req.poLine })
            .andWhere(`b.item_id IN (:...itemId)`, { itemId: req.itemId })
            .andWhere(`pb.bom_id is not null`)
            .andWhere(`d.file_id = ${req.fileId}`)
        // .groupBy(`st.id`)
        const rawData = await query.getRawMany()
        const mappedData: BomProposalDataModel[] = rawData.map(item => {
            return new BomProposalDataModel({
                id: item.id,
                poQty: item.poQty,
                bomQty: item.bomQty,
                consumption: item.consumption,
                wastage: item.wastage,
                moq: item.moq,
                description: item.description,
                imCode: item.imCode,
                use: item.use,
                styleNumber: item.styleNumber,
                color: item.color,
                destination: item.destination,
                geoCode: item.geoCode,
                plant: item.plant,
                season: item.season,
                year: item.year,
                size: item.size,
                itemNo: item.itemNo,
                itemId: item.itemId,
                gender: item.gender,
                poNumber: item.poNumber,
                combination: item.combination,
                primaryColor: item.primaryColor,
                secondaryColor: item.secondaryColor,
                itemColor: item.itemColor,
                productCode: item.productCode,
                styleCombo: item.stcomboId,
                bomId: item.bomId,
                bQty: item.bQty,
                attribute: item.attribute,
                attributeValue: item.attributeValue,
                totalGarmentQty: item.totalGarmentQty,
                uom: item.uom
            });
        });
        return mappedData;
    }
    async getProposalsDataForNeckTape(req: BomProposalReq): Promise<BomProposalDataModel[]> {
        const query = this.createQueryBuilder('pb')
            .select(`pb.id,pb.po_qty as poQty,pb.bom_qty as bomQty,pb.consumption,pb.wastage,pb.moq,b.description,b.im_code as imCode,b.use,
            d.style_number as styleNumber,d.color_desc as color,d.destination_country as destination,d.geo_code as geoCode,d.plant,d.planning_season_code as season,d.planning_season_year as year,d.size_description as size,SUBSTRING(d.bom_item, 1, 4) as itemNo,b.item_id as itemId,d.po_number as poNumber,d.gender_age_desc as gender,st.combination,st.primary_color as primaryColor,st.secondary_color as secondaryColor,st.item_color as itemColor,product_code as productCode,b.id AS bomId, st.id AS stcomboId, b.vendor_name as vendorName`)
            .leftJoin(PPMDataEntity, 'd', 'd.id = pb.dpom_id')
            .leftJoin(BomEntity, 'b', 'b.id = pb.bom_id and pb.bom_id is not null')
            .leftJoin(StyleComboEntity, 'st', 'st.bom_id = b.id and  st.combination = RIGHT(d.product_code, 3)')
            .where(`d.po_and_line IN (:...poLine)`, { poLine: req.poLine })
            .andWhere(`b.item_id IN (:...itemId)`, { itemId: req.itemId })
            .andWhere(`pb.bom_id is not null`)
            .andWhere(`d.file_id = ${req.fileId}`)
        // .orderBy(`d.bom_item`)
        const rawData = await query.getRawMany();
        const mappedData: BomProposalDataModel[] = rawData.map((item) => {
            return new BomProposalDataModel({
                id: item.id,
                poQty: item.poQty,
                bomQty: item.bomQty,
                consumption: item.consumption,
                wastage: item.wastage,
                moq: item.moq,
                description: item.description,
                imCode: item.imCode,
                use: item.use,
                styleNumber: item.styleNumber,
                color: item.color,
                destination: item.destination,
                geoCode: item.geoCode,
                plant: item.plant,
                season: item.season,
                year: item.year,
                size: item.size,
                itemNo: item.itemNo,
                itemId: item.itemId,
                gender: item.gender,
                poNumber: item.poNumber,
                combination: item.combination,
                primaryColor: item.primaryColor,
                secondaryColor: item.secondaryColor,
                itemColor: item.itemColor,
                productCode: item.productCode,
                styleCombo: item.stcomboId,
                bomId: item.bomId,
                vendorName:item.vendorName,
            });
        });
        return mappedData;
    }
    async getProposalsDataForTeeStyle(req: BomProposalReq): Promise<BomProposalDataModel[]> {
        const query = this.createQueryBuilder('pb')
            .select(`sm.fit,sm.fabric_code as fabricCode,sm.fabric_content as fabricContent,sm.fabric_combinations as fabricCombination,pb.id,pb.po_qty as poQty,pb.bom_qty as bomQty,pb.consumption,pb.wastage,pb.moq,b.description,b.im_code as imCode,b.use,
            d.style_number as styleNumber,d.color_desc as color,d.destination_country as destination,d.geo_code as geoCode,d.plant,d.planning_season_code as season,d.planning_season_year as year,d.size_description as size,SUBSTRING(d.bom_item, 1, 4) as itemNo,b.item_id as itemId,d.po_number as poNumber,d.gender_age_desc as gender,st.combination,st.primary_color as primaryColor,st.secondary_color as secondaryColor,sm.ht_color as itemColor,product_code as productCode,ia.attribute,ia.attribute_value as attributeValue,st.combination,b.qty as bBomQty`)
            .leftJoin(PPMDataEntity, 'd', 'd.id = pb.dpom_id')
            .leftJoin(BomEntity, 'b', 'b.id = pb.bom_id and pb.bom_id is not null')
            .leftJoin(StyleComboEntity, 'st', 'st.bom_id = b.id and  st.combination = RIGHT(d.product_code, 3)')
            .leftJoin(ItemAttributesEntity, 'ia', 'ia.item_id=b.item_id')
            .leftJoin(SizehtMatrixEntity, 'sm', 'sm.style=d.style_number and sm.im_code=b.im_code and is_active = 1')
            .where(`d.po_and_line IN (:...poLine)`, { poLine: req.poLine })
            .andWhere(`b.item_id IN (:...itemId)`, { itemId: req.itemId })
            .andWhere(`pb.bom_id is not null`)
            .andWhere(`b.description like'%TEE%'`)
            .andWhere(`d.file_id = ${req.fileId}`)

        const rawData = await query.getRawMany()
        const mappedData: BomProposalDataModel[] = rawData.map(item => {
            return new BomProposalDataModel({
                id: item.id,
                poQty: item.poQty,
                bomQty: item.bomQty,
                consumption: item.consumption,
                wastage: item.wastage,
                moq: item.moq,
                description: item.description,
                imCode: item.imCode,
                use: item.use,
                styleNumber: item.styleNumber,
                color: item.color,
                destination: item.destination,
                geoCode: item.geoCode,
                plant: item.plant,
                season: item.season,
                year: item.year,
                size: item.size,
                itemNo: item.itemNo,
                itemId: item.itemId,
                gender: item.gender,
                poNumber: item.poNumber,
                combination: item.combination,
                primaryColor: item.primaryColor,
                secondaryColor: item.secondaryColor,
                itemColor: item.itemColor,
                productCode: item.productCode,
                attribute: item.attribute,
                attributeValue: item.attributeValue,
                bQty: item.bBomQty,
                fit: item.fit,
                fabricCode: item.fabricCode,
                fabricCombination: item.fabricCombination,
                fabricContent: item.fabricContent

            });
        });
        return mappedData;
    }
    async getProposalsDataForPoloStyle(req: BomProposalReq): Promise<BomProposalDataModel[]> {
        const query = this.createQueryBuilder('pb')
            .select(`sm.fit,sm.fabric_code as fabricCode,sm.fabric_content as fabricContent,sm.fabric_combinations as fabricComboination,pb.id,pb.po_qty as poQty,pb.bom_qty as bomQty,pb.consumption,pb.wastage,pb.moq,b.description,b.im_code as imCode,b.use,
            d.style_number as styleNumber,d.color_desc as color,d.destination_country as destination,d.geo_code as geoCode,d.plant,d.planning_season_code as season,d.planning_season_year as year,d.size_description as size,SUBSTRING(d.bom_item, 1, 4) as itemNo,b.item_id as itemId,d.po_number as poNumber,d.gender_age_desc as gender,st.combination,st.primary_color as primaryColor,st.secondary_color as secondaryColor,st.item_color as itemColor,product_code as productCode,ia.attribute,ia.attribute_value as attributeValue,st.combination,b.qty as bBomQty`)
            .leftJoin(PPMDataEntity, 'd', 'd.id = pb.dpom_id')
            .leftJoin(BomEntity, 'b', 'b.id = pb.bom_id and pb.bom_id is not null')
            .leftJoin(StyleComboEntity, 'st', 'st.bom_id = b.id and  st.combination = RIGHT(d.product_code, 3)')
            .leftJoin(ItemAttributesEntity, 'ia', 'ia.item_id=b.item_id')
            .leftJoin(SizehtMatrixEntity, 'sm', 'sm.style=d.style_number and sm.im_code=b.im_code')
            .where(`d.po_and_line IN (:...poLine)`, { poLine: req.poLine })
            .andWhere(`b.item_id IN (:...itemId)`, { itemId: req.itemId })
            .andWhere(`pb.bom_id is not null`)
            .andWhere(`b.description like'%POLO%'`)
            .andWhere(`d.file_id = ${req.fileId}`)

        const rawData = await query.getRawMany()
        const mappedData: BomProposalDataModel[] = rawData.map(item => {
            return new BomProposalDataModel({
                id: item.id,
                poQty: item.poQty,
                bomQty: item.bomQty,
                consumption: item.consumption,
                wastage: item.wastage,
                moq: item.moq,
                description: item.description,
                imCode: item.imCode,
                use: item.use,
                styleNumber: item.styleNumber,
                color: item.color,
                destination: item.destination,
                geoCode: item.geoCode,
                plant: item.plant,
                season: item.season,
                year: item.year,
                size: item.size,
                itemNo: item.itemNo,
                itemId: item.itemId,
                gender: item.gender,
                poNumber: item.poNumber,
                combination: item.combination,
                primaryColor: item.primaryColor,
                secondaryColor: item.secondaryColor,
                itemColor: item.itemColor,
                productCode: item.productCode,
                attribute: item.attribute,
                attributeValue: item.attributeValue,
                bQty: item.bBomQty,
                fit: item.fit,
                fabricCode: item.fabricCode,
                fabricCombination: item.fabricCombination,
                fabricContent: item.fabricContent
            });
        });
        return mappedData;
    }

    async getProposalsDataSizewise(req: BomProposalReq): Promise<BomProposalDataModel[]> {
        const query = this.createQueryBuilder('pb')
            .select(`sm.fit,sm.fabric_code as fabricCode,sm.fabric_content as fabricContent,sm.fabric_combinations as fabricComboination,pb.id,pb.po_qty as poQty,pb.bom_qty as bomQty,pb.consumption,pb.wastage,pb.moq,b.description,b.im_code as imCode,b.use,
            d.style_number as styleNumber,d.color_desc as color,d.destination_country as destination,d.geo_code as geoCode,d.plant,d.planning_season_code as season,d.planning_season_year as year,d.size_description as size,SUBSTRING(d.bom_item, 1, 4) as itemNo,b.item_id as itemId,d.po_number as poNumber,d.gender_age_desc as gender,st.combination,st.primary_color as primaryColor,st.secondary_color as secondaryColor,st.item_color as itemColor,product_code as productCode,ia.attribute,ia.attribute_value as attributeValue,st.combination,b.qty as bBomQty`)
            .leftJoin(PPMDataEntity, 'd', 'd.id = pb.dpom_id')
            .leftJoin(BomEntity, 'b', 'b.id = pb.bom_id and pb.bom_id is not null')
            .leftJoin(StyleComboEntity, 'st', 'st.bom_id = b.id and  st.combination = RIGHT(d.product_code, 3)')
            .where(`d.po_and_line IN (:...poLine)`, { poLine: req.poLine })
            .andWhere(`b.item_id IN (:...itemId)`, { itemId: req.itemId })
            .andWhere(`pb.bom_id is not null`)
            .andWhere(`b.description like'%POLO%'`)
            .andWhere(`d.file_id = ${req.fileId}`)

        const rawData = await query.getRawMany()
        const mappedData: BomProposalDataModel[] = rawData.map(item => {
            return new BomProposalDataModel({
                id: item.id,
                poQty: item.poQty,
                bomQty: item.bomQty,
                consumption: item.consumption,
                wastage: item.wastage,
                moq: item.moq,
                description: item.description,
                imCode: item.imCode,
                use: item.use,
                styleNumber: item.styleNumber,
                color: item.color,
                destination: item.destination,
                geoCode: item.geoCode,
                plant: item.plant,
                season: item.season,
                year: item.year,
                size: item.size,
                itemNo: item.itemNo,
                itemId: item.itemId,
                gender: item.gender,
                poNumber: item.poNumber,
                combination: item.combination,
                primaryColor: item.primaryColor,
                secondaryColor: item.secondaryColor,
                itemColor: item.itemColor,
                productCode: item.productCode,
                attribute: item.attribute,
                attributeValue: item.attributeValue,
                bQty: item.bBomQty,
                fit: item.fit,
                fabricCode: item.fabricCode,
                fabricCombination: item.fabricCombination,
                fabricContent: item.fabricContent
            });
        });
        return mappedData;
    }
    async checkIfBomGenerated(dpomId, bomID, zfactorBomId) {
        const countQuery = await this.createQueryBuilder('pb')
            .select('id')
            .where(`dpom_id = ${dpomId}`)
        if (bomID) {
            countQuery.andWhere(`bom_id = ${bomID}`)
        }
        if (zfactorBomId) {
            countQuery.andWhere(`zfactor_bom_id = ${zfactorBomId}`)
        }
        const record = await countQuery.getRawOne()
        return record;

    }


    async getSizeStrip(req: BomProposalReq): Promise<BomProposalDataModel[]> {
        const query = this.createQueryBuilder('pb')
            .select(`pb.id,pb.po_qty as poQty,pb.bom_qty as bomQty,pb.consumption,pb.wastage,pb.moq,b.description,b.im_code as imCode,b.use,
            d.style_number as styleNumber,d.color_desc as color,d.destination_country as destination,d.geo_code as geoCode,d.plant,d.planning_season_code as season,d.planning_season_year as year,d.size_description as size,SUBSTRING(d.bom_item, 1, 4) as itemNo,b.item_id as itemId,d.po_number as poNumber,d.gender_age_desc as gender,st.combination,st.primary_color as primaryColor,st.secondary_color as secondaryColor,st.item_color as itemColor,product_code as productCode,st.combination,b.qty as bBomQty`)
            .leftJoin(PPMDataEntity, 'd', 'd.id = pb.dpom_id')
            .leftJoin(BomEntity, 'b', 'b.id = pb.bom_id and pb.bom_id is not null')
            .leftJoin(StyleComboEntity, 'st', 'st.bom_id = b.id and  st.combination = RIGHT(d.product_code, 3)')
            .where(`d.po_and_line IN (:...poLine)`, { poLine: req.poLine })
            .andWhere(`b.item_id IN (:...itemId)`, { itemId: req.itemId })
            .andWhere(`pb.bom_id is not null`)
        // .andWhere(`b.description like'%USA%'`)
           .andWhere(`d.file_id = ${req.fileId}`)

        const rawData = await query.getRawMany()
        const mappedData: BomProposalDataModel[] = rawData.map(item => {
            return new BomProposalDataModel({
                id: item.id,
                poQty: item.poQty,
                bomQty: item.bomQty,
                consumption: item.consumption,
                wastage: item.wastage,
                moq: item.moq,
                description: item.description,
                imCode: item.imCode,
                use: item.use,
                styleNumber: item.styleNumber,
                color: item.color,
                destination: item.destination,
                geoCode: item.geoCode,
                plant: item.plant,
                season: item.season,
                year: item.year,
                size: item.size,
                itemNo: item.itemNo,
                itemId: item.itemId,
                gender: item.gender,
                poNumber: item.poNumber,
                combination: item.combination,
                primaryColor: item.primaryColor,
                secondaryColor: item.secondaryColor,
                itemColor: item.itemColor,
                productCode: item.productCode,
                attribute: item.attribute,
                attributeValue: item.attributeValue,
                bQty: item.bBomQty
            });
        });
        return mappedData;
    }



    async generateProposalForHmSheet(req: BomProposalReq): Promise<BomProposalDataModel[]> {

        const query = this.createQueryBuilder('pb')
            .select(`SUBSTRING(d.bom_item, 1, 4) AS itemNo, d.style_number AS styleNumber,pb.bom_qty AS bomQty,hm.teflon_sheet_size AS teflonSheetSize,
            pb.id,pb.po_qty AS poQty,pb.consumption,pb.wastage,pb.moq,zb.description,
            d.color_desc AS color,d.destination_country AS destination,d.geo_code AS geoCode,
            d.plant,d.planning_season_code AS season,d.planning_season_year AS YEAR,d.size_description AS size,
            z.item_id AS itemId,d.po_number AS poNumber,d.gender_age_desc AS gender
            `)
            .leftJoin(PPMDataEntity, 'd', 'd.id = pb.dpom_id')
            .leftJoin(ZFactorsBomEntity, 'zb', 'zb.id = pb.zfactor_bom_id and pb.zfactor_bom_id is not null')
            .leftJoin(ZFactorsEntity, 'z', 'z.id = zb.zfactor_id ')
            .innerJoin(HMStyleEntity, 'hm', 'hm.style_number = d.style_number')
            .where(`d.po_and_line IN (:...poLine)`, { poLine: req.poLine })
            .andWhere(`z.item_id IN (:...itemId)`, { itemId: req.itemId })
            .andWhere(`pb.zfactor_bom_id is not null `)
            .andWhere(`d.file_id = ${req.fileId}`)
        const rawData = await query.getRawMany();
        const mappedData: BomProposalDataModel[] = rawData.map((item) => {
            return new BomProposalDataModel({
                id: item.id,
                poQty: item.poQty,
                bomQty: item.bomQty,
                consumption: item.consumption,
                wastage: item.wastage,
                moq: item.moq,
                description: item.description,
                styleNumber: item.styleNumber,
                color: item.color,
                destination: item.destination,
                geoCode: item.geoCode,
                plant: item.plant,
                season: item.season,
                year: item.year,
                size: item.size,
                itemNo: item.itemNo,
                itemId: item.itemId,
                gender: item.gender,
                poNumber: item.poNumber,
                combination: item.combination,
                primaryColor: item.primaryColor,
                secondaryColor: item.secondaryColor,
                itemColor: item.itemColor,
                productCode: item.productCode,
                styleCombo: item.stcomboId,
                bomId: item.bomId,
                teflonSheetSize: item.teflonSheetSize,

            });
        });
        return mappedData;
    }

    async getBackingPaperV2(req: BomProposalReq): Promise<BomProposalDataModel[]> {
        const query = this.createQueryBuilder('pb')
            .select(`pb.id,pb.po_qty as poQty,pb.bom_qty as bomQty,pb.consumption,pb.wastage,pb.moq,b.description,b.im_code as imCode,b.use,
            d.style_number as styleNumber,d.color_desc as color,d.destination_country as destination,d.geo_code as geoCode,d.plant,d.planning_season_code as season,d.planning_season_year as year,d.size_description as size,SUBSTRING(d.bom_item, 1, 4) as itemNo,b.item_id as itemId,d.po_number as poNumber,d.gender_age_desc as gender,st.combination,st.primary_color as primaryColor,st.secondary_color as secondaryColor,st.item_color as itemColor,product_code as productCode,st.combination,b.qty as bBomQty,bp.non_woven_colour as nowovencolor`)
            .leftJoin(PPMDataEntity, 'd', 'd.id = pb.dpom_id')
            .leftJoin(BomEntity, 'b', 'b.id = pb.bom_id and pb.bom_id is not null')
            .leftJoin(StyleComboEntity, 'st', 'st.bom_id = b.id and  st.combination = RIGHT(d.product_code, 3)')
            .leftJoin(BackingPaperV2, 'bp', 'bp.garment_colour_code=d.color_desc')
            .where(`d.po_and_line IN (:...poLine)`, { poLine: req.poLine })
            .andWhere(`b.item_id IN (:...itemId)`, { itemId: req.itemId })
            .andWhere(`pb.bom_id is not null`)
            .andWhere(`d.file_id = ${req.fileId}`)
        // .andWhere(`b.description like'%USA%'`)

        const rawData = await query.getRawMany()
        const mappedData: BomProposalDataModel[] = rawData.map(item => {
            return new BomProposalDataModel({
                id: item.id,
                poQty: item.poQty,
                bomQty: item.bomQty,
                consumption: item.consumption,
                wastage: item.wastage,
                moq: item.moq,
                description: item.description,
                imCode: item.imCode,
                use: item.use,
                styleNumber: item.styleNumber,
                color: item.color,
                destination: item.destination,
                geoCode: item.geoCode,
                plant: item.plant,
                season: item.season,
                year: item.year,
                size: item.size,
                itemNo: item.itemNo,
                itemId: item.itemId,
                gender: item.gender,
                poNumber: item.poNumber,
                combination: item.combination,
                primaryColor: item.primaryColor,
                secondaryColor: item.secondaryColor,
                itemColor: item.itemColor,
                productCode: item.productCode,
                attribute: item.attribute,
                attributeValue: item.attributeValue,
                bQty: item.bBomQty,
                nonwovencolor: item.nonwovencolor,
            });
        });
        return mappedData;
    }
    async getPatchLabel(req: BomProposalReq): Promise<BomProposalDataModel[]> {
        const query = this.createQueryBuilder('pb')
            .select(`pb.id,pb.po_qty as poQty,pb.bom_qty as bomQty,pb.consumption,pb.wastage,pb.moq,b.description,b.im_code as imCode,b.use,
            d.style_number as styleNumber,d.color_desc as color,d.destination_country as destination,d.geo_code as geoCode,d.plant,d.planning_season_code as season,d.planning_season_year as year,d.size_description as size,SUBSTRING(d.bom_item, 1, 4) as itemNo,b.item_id as itemId,d.po_number as poNumber,d.gender_age_desc as gender,st.combination,st.primary_color as primaryColor,st.secondary_color as secondaryColor,st.item_color as itemColor,product_code as productCode,ia.attribute,ia.attribute_value as attributeValue,st.combination,b.qty as bBomQty,DATE_FORMAT(d.ogac, '%d-%b') AS ogacDate,d.po_and_line as poAndLine , b.vendor_name as vendorName`)
            // SUBSTRING(d.ogac, 1, 7) as ogacDate , 
            .leftJoin(PPMDataEntity, 'd', 'd.id = pb.dpom_id')
            .leftJoin(BomEntity, 'b', 'b.id = pb.bom_id and pb.bom_id is not null')
            .leftJoin(StyleComboEntity, 'st', 'st.bom_id = b.id and  st.combination = RIGHT(d.product_code, 3)')
            .leftJoin(ItemAttributesEntity, 'ia', 'ia.item_id=b.item_id')
            // .leftJoin(ZipperEntity,)
            .where(`d.po_and_line IN (:...poLine)`, { poLine: req.poLine })
            .andWhere(`b.item_id IN (:...itemId)`, { itemId: req.itemId })
            .andWhere(`pb.bom_id is not null`)
            .andWhere(`d.file_id = ${req.fileId}`)

        const rawData = await query.getRawMany()
        const mappedData: BomProposalDataModel[] = rawData.map(item => {
            return new BomProposalDataModel({
                id: item.id,
                poQty: item.poQty,
                bomQty: item.bomQty,
                consumption: item.consumption,
                wastage: item.wastage,
                moq: item.moq,
                description: item.description,
                imCode: item.imCode,
                use: item.use,
                styleNumber: item.styleNumber,
                color: item.color,
                destination: item.destination,
                geoCode: item.geoCode,
                plant: item.plant,
                season: item.season,
                year: item.year,
                size: item.size,
                itemNo: item.itemNo,
                itemId: item.itemId,
                gender: item.gender,
                poNumber: item.poNumber,
                combination: item.combination,
                primaryColor: item.primaryColor,
                secondaryColor: item.secondaryColor,
                itemColor: item.itemColor,
                productCode: item.productCode,
                attribute: item.attribute,
                attributeValue: item.attributeValue,
                bQty: item.bBomQty,
                ogacDate: item.ogacDate,
                poAndLine: item.poAndLine,
                vendorName :item.vendorName
            });
        });
        return mappedData;
    }

    async getZfactorsDataForCartonBox(req: BomProposalReq): Promise<BomProposalDataModel[]> {
        const query = this.createQueryBuilder('pb')
            .select(`pb.id,pb.po_qty as poQty,pb.bom_qty as bomQty,pb.consumption,pb.wastage,pb.moq,
            d.style_number as styleNumber,d.color_desc as color,d.destination_country as destination,d.geo_code as geoCode,d.plant,d.planning_season_code as season,d.planning_season_year as year,d.size_description as size,SUBSTRING(d.bom_item, 1, 4) as itemNo,z.item_id as itemId,pb.zfactor_bom_id as zfactorBomId,zb.im_code as zbImCode,zb.item_name as zbItemName,zb.description,d.po_number as poNumber,d.gender_age_desc as gender, d.ogac as ogacDate,d.gac as gacDate,TRIM(LEADING '0' FROM d.ship_to_customer_no) as shipToNumber,zb.sequence,c.carton_code as cartonCode,
            CASE
            WHEN d.size_description IN ('XS', 'S', 'M', 'L') THEN CONCAT('S to L ', c.s_l)
            ELSE CONCAT('XL to Bal ', c.xl_bal)
            END as noOfPcsPerCarton
            ,d.item_vas_text as itemVasText,d.factory,d.po_and_line as poAndLine,item_vas_text as itemVasText,d.cab_code as cabCode,d.po_line_item_number as poLineItemNumber`)
            .leftJoin(PPMDataEntity, 'd', 'd.id = pb.dpom_id')
            .leftJoin(CartonBoxEntity, 'c', 'c.style  = d.style_number ')
            .leftJoin(ZFactorsBomEntity, 'zb', 'zb.id = pb.zfactor_bom_id and pb.zfactor_bom_id is not null')
            .leftJoin(ZFactorsEntity, 'z', 'z.id = zb.zfactor_id ')
            .where(`d.po_and_line IN (:...poLine)`, { poLine: req.poLine })
            .andWhere(`z.item_id IN (:...itemId)`, { itemId: req.itemId })
            .andWhere(`pb.zfactor_bom_id is not null`)
            .andWhere(`d.file_id = ${req.fileId}`)

        const rawData = await query.getRawMany()
        const mappedData: BomProposalDataModel[] = rawData.map(item => {
            return new BomProposalDataModel({
                id: item.id,
                poQty: item.poQty,
                bomQty: item.bomQty,
                consumption: item.consumption,
                wastage: item.wastage,
                moq: item.moq,
                description: item.description,
                imCode: item.zbImCode,
                use: item.use,
                styleNumber: item.styleNumber,
                color: item.color,
                destination: item.destination,
                geoCode: item.geoCode,
                plant: item.plant,
                season: item.season,
                year: item.year,
                size: item.size,
                itemNo: item.itemNo,
                itemId: item.itemId,
                gender: item.gender,
                poNumber: item.poNumber,
                ogacDate: item.ogacDate,
                shipToNumber: item.shipToNumber,
                sequence: item.sequence,
                cartonCode: item.cartonCode,
                itemVasText: item.itemVasText,
                factory: item.factory,
                gacDate: item.gacDate,
                poAndLine: item.poAndLine,
                noOfPcsPerCarton: item.noOfPcsPerCarton,
                cabCode: item.cabCode,
                poLineItemNumber: item.poLineItemNumber,
            });
        });

        return mappedData;
    }



    async generateGSISticker(req: BomProposalReq): Promise<BomProposalDataModel[]> {
        const query = this.createQueryBuilder('pb')
            .select(`pb.id,pb.po_qty AS poQty,pb.bom_qty AS bomQty,pb.consumption,pb.wastage,pb.moq,b.description,b.im_code AS imCode,
            b.use,b.uom,d.style_number AS styleNumber,d.color_desc AS color,d.destination_country AS destination,d.geo_code AS geoCode,d.plant,
            d.planning_season_code AS season,d.planning_season_year AS year,d.size_description AS size,SUBSTRING(d.bom_item, 1, 4) AS itemNo,
            b.item_id AS itemId,d.po_number AS poNumber,d.gender_age_desc AS gender, SUBSTRING(d.ogac, 1, 7) AS ogacDate,
            TRIM(LEADING '0' FROM d.ship_to_customer_no) AS shipToNumber, b.sequence,s.style AS style,s.style_name AS styleName`)
            .leftJoin(PPMDataEntity, 'd', 'd.id = pb.dpom_id')
            .leftJoin(BomEntity, 'b', 'b.id = pb.bom_id and pb.bom_id is not null')
            .leftJoin(StyleComboEntity, 'st', 'st.bom_id = b.id and  st.combination = RIGHT(d.product_code, 3)')
            .leftJoin(StyleEntity, 's', 's.id=b.style_id')
            .where(`d.po_and_line IN (:...poLine)`, { poLine: req.poLine })
            .andWhere(`b.item_id IN (:...itemId)`, { itemId: req.itemId })
            .andWhere(`pb.bom_id is not null`)
            .andWhere(`d.file_id = ${req.fileId}`)
        // .andWhere(`s.style_name LIKE "%FLC%"`)
        // .andWhere(`s.style_name LIKE "%POLO%"`)
        // .andWhere(`s.style_name LIKE "%TEE%"`)


        const rawData = await query.getRawMany()
        const mappedData: BomProposalDataModel[] = rawData.map(item => {
            return new BomProposalDataModel({
                id: item.id,
                poQty: item.poQty,
                bomQty: item.bomQty,
                consumption: item.consumption,
                wastage: item.wastage,
                moq: item.moq,
                description: item.description,
                imCode: item.imCode,
                use: item.use,
                styleNumber: item.styleNumber,
                styleName: item.styleName,
                color: item.color,
                destination: item.destination,
                geoCode: item.geoCode,
                plant: item.plant,
                season: item.season,
                year: item.year,
                size: item.size,
                itemNo: item.itemNo,
                itemId: item.itemId,
                gender: item.gender,
                poNumber: item.poNumber,
                combination: item.combination,
                primaryColor: item.primaryColor,
                secondaryColor: item.secondaryColor,
                itemColor: item.itemColor,
                productCode: item.productCode,
                bQty: item.bBomQty,
            });
        });
        return mappedData;
    }

    async getProposalsDataForZipper(req: BomProposalReq): Promise<BomProposalDataModel[]> {
        const query = this.createQueryBuilder('pb')
            .select(`pb.id,pb.po_qty as poQty,pb.bom_qty as bomQty,pb.consumption,pb.wastage,pb.moq,b.description,b.im_code as imCode,b.use
            ,d.color_desc as color,d.destination_country as destination,d.geo_code as geoCode,d.plant,d.planning_season_code as season,d.planning_season_year as year,SUBSTRING(d.bom_item, 1, 4) as itemNo,b.item_id as itemId,d.po_number as poNumber,d.gender_age_desc as gender,st.combination,st.primary_color as primaryColor,st.secondary_color as secondaryColor,st.item_color as itemColor,product_code as productCode,b.id AS bomId, st.id AS stcomboId ,size_qty AS totalGarmentQty,b.uom as uom,z.size as size , z.style as styleNumber,z.consumption as zipperConsumption,GROUP_CONCAT(st.item_color) as concatedItemColors`)
            .leftJoin(PPMDataEntity, 'd', 'd.id = pb.dpom_id')
            .leftJoin(BomEntity, 'b', 'b.id = pb.bom_id and pb.bom_id is not null')
            .leftJoin(StyleComboEntity, 'st', 'st.bom_id = b.id and  st.combination = RIGHT(d.product_code, 3)')
            .leftJoin(ZipperEntity, 'z', 'z.style = d.style_number and d.size_description = z.size')
            .where(`d.po_and_line IN (:...poLine)`, { poLine: req.poLine })
            .andWhere(`b.item_id IN (:...itemId)`, { itemId: req.itemId })
            .andWhere(`pb.bom_id is not null and z.style is not null`)
            .andWhere(`d.file_id = ${req.fileId}`)
            .groupBy(`st.combination,d.id`)

        // .groupBy(`st.id`)
        const rawData = await query.getRawMany()
        const mappedData: BomProposalDataModel[] = rawData.map(item => {
            return new BomProposalDataModel({
                id: item.id,
                poQty: item.poQty,
                bomQty: item.bomQty,
                consumption: item.consumption,
                wastage: item.wastage,
                moq: item.moq,
                description: item.description,
                imCode: item.imCode,
                use: item.use,
                styleNumber: item.styleNumber,
                color: item.color,
                destination: item.destination,
                geoCode: item.geoCode,
                plant: item.plant,
                season: item.season,
                year: item.year,
                size: item.size,
                itemNo: item.itemNo,
                itemId: item.itemId,
                gender: item.gender,
                poNumber: item.poNumber,
                combination: item.combination,
                primaryColor: item.primaryColor,
                secondaryColor: item.secondaryColor,
                itemColor: item.concatedItemColors,
                productCode: item.productCode,
                styleCombo: item.stcomboId,
                bomId: item.bomId,
                bQty: item.bQty,
                attribute: item.attribute,
                attributeValue: item.attributeValue,
                totalGarmentQty: item.totalGarmentQty,
                uom: item.uom,
                zipperConsumption: item.zipperConsumption,
            });
        });
        return mappedData;
    }

    async generateProposalForMobillionTape(req: BomProposalReq): Promise<BomProposalDataModel[]> {
        const query = this.createQueryBuilder('pb')
            .select(`pb.id,pb.po_qty as poQty,pb.bom_qty as bomQty,pb.consumption,pb.wastage,pb.moq,b.description,b.im_code as imCode,b.use,
            d.style_number as styleNumber,d.color_desc as color,d.destination_country as destination,d.geo_code as geoCode,d.plant,d.planning_season_code as season,d.planning_season_year as year,d.size_description as size,SUBSTRING(d.bom_item, 1, 4) as itemNo,b.item_id as itemId,d.po_number as poNumber,d.gender_age_desc as gender,product_code as productCode,b.qty as bBomQty,pb.op_uom as opUom,ip_uom as ipUom`)
            .leftJoin(PPMDataEntity, 'd', 'd.id = pb.dpom_id')
            .leftJoin(BomEntity, 'b', 'b.id = pb.bom_id and pb.bom_id is not null')
            .where(`d.po_and_line IN (:...poLine)`, { poLine: req.poLine })
            .andWhere(`b.item_id IN (:...itemId)`, { itemId: req.itemId })
            .andWhere(`pb.bom_id is not null`)
            .andWhere(`d.file_id = ${req.fileId}`)
        // .andWhere(`b.description like'%USA%'`)

        const rawData = await query.getRawMany()
        const mappedData: BomProposalDataModel[] = rawData.map(item => {
            return new BomProposalDataModel({
                id: item.id,
                poQty: item.poQty,
                bomQty: item.bomQty,
                consumption: item.consumption,
                wastage: item.wastage,
                moq: item.moq,
                description: item.description,
                imCode: item.imCode,
                use: item.use,
                styleNumber: item.styleNumber,
                color: item.color,
                destination: item.destination,
                geoCode: item.geoCode,
                plant: item.plant,
                season: item.season,
                year: item.year,
                size: item.size,
                itemNo: item.itemNo,
                itemId: item.itemId,
                gender: item.gender,
                poNumber: item.poNumber,
                combination: item.combination,
                primaryColor: item.primaryColor,
                secondaryColor: item.secondaryColor,
                itemColor: item.itemColor,
                productCode: item.productCode,
                attribute: item.attribute,
                attributeValue: item.attributeValue,
                bQty: item.bBomQty,
                uom: item.ipUom,
                opUom: item.opUom
            });
        });
        return mappedData;
    }

    async getZfactorsDataForKimble(req: BomProposalReq): Promise<BomProposalDataModel[]> {
        const query = this.createQueryBuilder('pb')
            .select(`pb.id,pb.po_qty as poQty,pb.bom_qty as bomQty,pb.consumption,pb.wastage,pb.moq,
            d.style_number as styleNumber,d.color_desc as color,d.destination_country as destination,d.geo_code as geoCode,d.plant,d.planning_season_code as season,d.planning_season_year as year,d.size_description as size,SUBSTRING(d.bom_item, 1, 4) as itemNo,z.item_id as itemId,pb.zfactor_bom_id as zfactorBomId,zb.im_code as zbImCode,zb.item_name as zbItemName,zb.description,d.po_number as poNumber,d.gender_age_desc as gender, SUBSTRING(d.ogac, 1, 7) as ogacDate, SUBSTRING(d.ogac, 1, 7) as ogacDate,TRIM(LEADING '0' FROM d.ship_to_customer_no) as shipToNumber,zb.sequence,d.po_and_line as poAndLine,s.kimble_size as kimbleSize`)
            .leftJoin(PPMDataEntity, 'd', 'd.id = pb.dpom_id')
            .leftJoin(StyleEntity, 's', 's.style = d.style_number and s.season = d.planning_season_code and s.year = d.planning_season_year')
            .leftJoin(ZFactorsBomEntity, 'zb', 'zb.id = pb.zfactor_bom_id and pb.zfactor_bom_id is not null')
            .leftJoin(ZFactorsEntity, 'z', 'z.id = zb.zfactor_id ')
            .where(`d.po_and_line IN (:...poLine)`, { poLine: req.poLine })
            .andWhere(`z.item_id IN (:...itemId)`, { itemId: req.itemId })
            .andWhere(`pb.zfactor_bom_id is not null`)
            .andWhere(`d.file_id = ${req.fileId}`)

        const rawData = await query.getRawMany()
        const mappedData: BomProposalDataModel[] = rawData.map(item => {
            return new BomProposalDataModel({
                id: item.id,
                poQty: item.poQty,
                bomQty: item.bomQty,
                consumption: item.consumption,
                wastage: item.wastage,
                moq: item.moq,
                description: item.description,
                imCode: item.zbImCode,
                use: item.use,
                styleNumber: item.styleNumber,
                color: item.color,
                destination: item.destination,
                geoCode: item.geoCode,
                plant: item.plant,
                season: item.season,
                year: item.year,
                size: item.size,
                itemNo: item.itemNo,
                itemId: item.itemId,
                gender: item.gender,
                poNumber: item.poNumber,
                ogacDate: item.ogacDate,
                shipToNumber: item.shipToNumber,
                sequence: item.sequence,
                poAndLine: item.poAndLine,
                kimbleSize: item.kimbleSize
            });
        });

        return mappedData;
    }

    async generateProposalForTissuePaper(req: BomProposalReq): Promise<BomProposalDataModel[]> {

        const query = this.createQueryBuilder('pb')
            .select(`SUBSTRING(d.bom_item, 1, 4) AS itemNo, d.style_number AS styleNumber,pb.bom_qty AS bomQty,t.size AS tissuePaperSize,
            pb.id,pb.po_qty AS poQty,pb.consumption,pb.wastage,pb.moq,zb.description,
            d.color_desc AS color,d.destination_country AS destination,d.geo_code AS geoCode,
            d.plant,d.planning_season_code AS season,d.planning_season_year AS YEAR,d.size_description AS size,
            z.item_id AS itemId,d.po_number AS poNumber,d.gender_age_desc AS gender
            `)
            .leftJoin(PPMDataEntity, 'd', 'd.id = pb.dpom_id')
            .leftJoin(ZFactorsBomEntity, 'zb', 'zb.id = pb.zfactor_bom_id and pb.zfactor_bom_id is not null')
            .leftJoin(ZFactorsEntity, 'z', 'z.id = zb.zfactor_id ')
            .innerJoin(TissuePaperEntity, 't', 't.style_number = d.style_number')
            .where(`d.po_and_line IN (:...poLine)`, { poLine: req.poLine })
            .andWhere(`z.item_id IN (:...itemId)`, { itemId: req.itemId })
            .andWhere(`pb.zfactor_bom_id is not null `)
            .andWhere(`d.file_id = ${req.fileId}`)
        const rawData = await query.getRawMany();
        const mappedData: BomProposalDataModel[] = rawData.map((item) => {
            return new BomProposalDataModel({
                id: item.id,
                poQty: item.poQty,
                bomQty: item.bomQty,
                consumption: item.consumption,
                wastage: item.wastage,
                moq: item.moq,
                description: item.description,
                styleNumber: item.styleNumber,
                color: item.color,
                destination: item.destination,
                geoCode: item.geoCode,
                plant: item.plant,
                season: item.season,
                year: item.year,
                size: item.size,
                itemNo: item.itemNo,
                itemId: item.itemId,
                gender: item.gender,
                poNumber: item.poNumber,
                combination: item.combination,
                primaryColor: item.primaryColor,
                secondaryColor: item.secondaryColor,
                itemColor: item.itemColor,
                productCode: item.productCode,
                bomId: item.bomId,
                tissuePaperSize: item.tissuePaperSize,

            });
        });
        return mappedData;
    }

    async getStylesAndImsForSelectedItems(req: any) {
        const items = req.items
        const itemsString = items.map(item => `'${item}'`).join(',');

        const query = `SELECT d.style_number as value,b.im_code as imCode,s.id FROM ppm_data d
        LEFT JOIN styles s ON s.style = d.style_number
        INNER JOIN bom b ON b.style_id = s.id AND b.item_id = 26 
        WHERE bom_item IN (${itemsString}) GROUP BY style_number , b.im_code`
        const res = await this.query(query)
        return res
    }

    async generateForbackingPaper(req: BomProposalReq): Promise<BomProposalDataModel[]> {
        const query = this.createQueryBuilder('pb')
            .select(`pb.id,pb.po_qty as poQty,pb.bom_qty as bomQty,pb.consumption,pb.wastage,pb.moq,b.description,b.im_code as imCode,b.use,
            d.style_number as styleNumber,d.color_desc as color,d.destination_country as destination,d.geo_code as geoCode,d.plant,d.planning_season_code as season,d.planning_season_year as year,d.size_description as size,SUBSTRING(d.bom_item, 1, 4) as itemNo,b.item_id as itemId,d.po_number as poNumber,d.gender_age_desc as gender,COALESCE(st.combination, bv.combination) as combination,COALESCE(st.primary_color, bv.garment_colour_code) as primaryColor,st.secondary_color as secondaryColor, COALESCE(st.item_color, bv.non_woven_colour) as itemColor,
            product_code as productCode,ia.attribute,ia.attribute_value as attributeValue,b.qty as bBomQty,DATE_FORMAT(d.ogac, '%d-%b') as ogacDate, op_uom as opUom,d.po_and_line as poAndLine,pb.bom_id as bomId `)
            // SUBSTRING(d.ogac, 1, 7) as ogacDate , 
            .leftJoin(PPMDataEntity, 'd', 'd.id = pb.dpom_id')
            .leftJoin(BomEntity, 'b', 'b.id = pb.bom_id and pb.bom_id is not null')
            .leftJoin(StyleComboEntity, 'st', 'st.bom_id = pb.bom_id and st.combination = RIGHT(d.product_code, 3) and st.item_color is not null')
            .leftJoin(ItemAttributesEntity, 'ia', 'ia.item_id=b.item_id')
            .leftJoin(BackingPaperV2, 'bv', 'bv.combination = RIGHT(d.product_code, 3) AND st.combination IS NULL')
            .where(`d.po_and_line IN (:...poLine)`, { poLine: req.poLine })
            .andWhere(`b.item_id IN (:...itemId)`, { itemId: req.itemId })
            .andWhere(`pb.bom_id is not null`)
            .andWhere(`d.file_id = ${req.fileId}`)
        const rawData = await query.getRawMany()
        const mappedData: BomProposalDataModel[] = rawData.map(item => {
            return new BomProposalDataModel({
                id: item.id,
                poQty: item.poQty,
                bomQty: item.bomQty,
                consumption: item.consumption,
                wastage: item.wastage,
                moq: item.moq,
                description: item.description,
                imCode: item.imCode,
                use: item.use,
                styleNumber: item.styleNumber,
                color: item.color,
                destination: item.destination,
                geoCode: item.geoCode,
                plant: item.plant,
                season: item.season,
                year: item.year,
                size: item.size,
                itemNo: item.itemNo,
                itemId: item.itemId,
                gender: item.gender,
                poNumber: item.poNumber,
                combination: item.combination,
                primaryColor: item.primaryColor,
                secondaryColor: item.secondaryColor,
                itemColor: item.itemColor,
                productCode: item.productCode,
                attribute: item.attribute,
                attributeValue: item.attributeValue,
                bQty: item.bBomQty,
                ogacDate: item.ogacDate,
                opUom: item.opUom,
                poAndLine: item.poAndLine,
                bomId: item.bomId,
                nonWovenColor: item.nonWovenColor,
                bvCombination: item.bvCombination

            });
        });
        return mappedData;
    }

    async generatePRoposalForSizeHt(req: BomProposalReq): Promise<BomProposalDataModel[]> {

        const query = this.createQueryBuilder('pb')
            .select(`pb.id,pb.po_qty as poQty,pb.bom_qty as bomQty,pb.consumption,pb.wastage,pb.moq,b.description,b.im_code as imCode,b.use,
            d.style_number as styleNumber,d.color_desc as color,d.destination_country as destination,d.geo_code as geoCode,d.plant,d.planning_season_code as season,d.planning_season_year as year,d.size_description as size,SUBSTRING(d.bom_item, 1, 4) as itemNo,b.item_id as itemId,d.po_number as poNumber,d.gender_age_desc as gender,st.primary_color as primaryColor,st.secondary_color as secondaryColor,st.item_color as itemColor,product_code as productCode,st.combination,b.qty as bBomQty,DATE_FORMAT(d.ogac, '%d-%b') as ogacDate, op_uom as opUom,d.po_and_line as poAndLine,pb.bom_id as bomId,s.style_name as styleName,sh.fabric_code as fabricCode,sh.fabric_content as fabricContent,sh.fit,sh.ht_color as htColor`)
            // SUBSTRING(d.ogac, 1, 7) as ogacDate , 
            .leftJoin(PPMDataEntity, 'd', 'd.id = pb.dpom_id')
            .leftJoin(BomEntity, 'b', 'b.id = pb.bom_id and pb.bom_id is not null')
            .leftJoin(StyleEntity, 's', 's.style = d.style_number and s.season = d.planning_season_code and s.year = d.planning_season_year')
            .leftJoin(StyleComboEntity, 'st', 'st.bom_id = pb.bom_id and st.combination = RIGHT(d.product_code, 3)')
            .leftJoin(SizehtMatrixEntity, 'sh', `sh.style LIKE CONCAT('%', d.style_number, '%')
            AND sh.fabric_combinations LIKE CONCAT('%', st.combination, '%') and sh.is_active = 1`)
            .where(`d.po_and_line IN (:...poLine)`, { poLine: req.poLine })
            .andWhere(`b.item_id IN (:...itemId)`, { itemId: req.itemId })
            .andWhere(`pb.bom_id is not null`)
            .andWhere(`d.file_id = ${req.fileId}`)
            .andWhere(`sh.is_active = 1`)

        const rawData = await query.getRawMany()
        const mappedData: BomProposalDataModel[] = rawData.map(item => {
            return new BomProposalDataModel({
                id: item.id,
                poQty: item.poQty,
                bomQty: item.bomQty,
                consumption: item.consumption,
                wastage: item.wastage,
                moq: item.moq,
                description: item.description,
                imCode: item.imCode,
                use: item.use,
                styleNumber: item.styleNumber,
                color: item.color,
                destination: item.destination,
                geoCode: item.geoCode,
                plant: item.plant,
                season: item.season,
                year: item.year,
                size: item.size,
                itemNo: item.itemNo,
                itemId: item.itemId,
                gender: item.gender,
                poNumber: item.poNumber,
                combination: item.combination,
                primaryColor: item.primaryColor,
                secondaryColor: item.secondaryColor,
                itemColor: item.itemColor,
                productCode: item.productCode,
                attribute: item.attribute,
                attributeValue: item.attributeValue,
                bQty: item.bBomQty,
                ogacDate: item.ogacDate,
                opUom: item.opUom,
                poAndLine: item.poAndLine,
                bomId: item.bomId,
                styleName: item.styleName,
                fabricCode: item.fabricCode,
                fabricContent: item.fabricContent,
                fit: item.fit,
                htColor : item.htColor
            });
        });
        return mappedData;
    }

    async getBomAndImsForSelectedItems(req: any) {
        const items = req.items
        const itemsString = items.map(item => `'${item}'`).join(',');
        const query = `SELECT d.bom_item as value,b.im_code as imCode,s.id FROM ppm_data d
        LEFT JOIN styles s ON s.style = d.style_number
        INNER JOIN bom b ON b.style_id = s.id AND b.item_id = ${req.itemId}
        WHERE d.bom_item IN (${itemsString}) GROUP BY d.bom_item , b.im_code`
        const res = await this.query(query)
        return res
    }

    async generateInterlining(req: BomProposalReq): Promise<BomProposalDataModel[]> {
        const query = this.createQueryBuilder('pb')
            .select(`pb.id,pb.po_qty as poQty,pb.bom_qty as bomQty,pb.consumption,pb.wastage,pb.moq,b.description,b.im_code as imCode,b.use,
            d.style_number as styleNumber,d.color_desc as color,d.destination_country as destination,d.geo_code as geoCode,d.plant,d.planning_season_code as season,d.planning_season_year as year,d.size_description as size,SUBSTRING(d.bom_item, 1, 4) as itemNo,b.item_id as itemId,d.po_number as poNumber,d.gender_age_desc as gender,st.combination,st.primary_color as primaryColor,st.secondary_color as secondaryColor,st.item_color as itemColor,product_code as productCode,st.combination,b.qty as bBomQty,DATE_FORMAT(d.ogac, '%d-%b') as ogacDate, op_uom as opUom,d.po_and_line as poAndLine,pb.bom_id as bomId`)
            // SUBSTRING(d.ogac, 1, 7) as ogacDate , 
            .leftJoin(PPMDataEntity, 'd', 'd.id = pb.dpom_id')
            .leftJoin(BomEntity, 'b', 'b.id = pb.bom_id and pb.bom_id is not null')
            .leftJoin(StyleComboEntity, 'st', 'st.bom_id = pb.bom_id and st.combination = RIGHT(d.product_code, 3)')
            .where(`d.po_and_line IN (:...poLine)`, { poLine: req.poLine })
            .andWhere(`b.item_id IN (:...itemId)`, { itemId: req.itemId })
            .andWhere(`pb.bom_id is not null`)
            .andWhere(`d.file_id = ${req.fileId}`)
        const rawData = await query.getRawMany()
        const mappedData: BomProposalDataModel[] = rawData.map(item => {
            return new BomProposalDataModel({
                id: item.id,
                poQty: item.poQty,
                bomQty: item.bomQty,
                consumption: item.consumption,
                wastage: item.wastage,
                moq: item.moq,
                description: item.description,
                imCode: item.imCode,
                use: item.use,
                styleNumber: item.styleNumber,
                color: item.color,
                destination: item.destination,
                geoCode: item.geoCode,
                plant: item.plant,
                season: item.season,
                year: item.year,
                size: item.size,
                itemNo: item.itemNo,
                itemId: item.itemId,
                gender: item.gender,
                poNumber: item.poNumber,
                combination: item.combination,
                primaryColor: item.primaryColor,
                secondaryColor: item.secondaryColor,
                itemColor: item.itemColor,
                productCode: item.productCode,
                bQty: item.bBomQty,
                ogacDate: item.ogacDate,
                opUom: item.opUom,
                poAndLine: item.poAndLine,
                bomId: item.bomId

            });
        });
        return mappedData;
    }

    async getProposalsDataForHangtag(req: BomProposalReq): Promise<BomProposalDataModel[]> {
        const query = this.createQueryBuilder('pb')
            .select(`pb.id,pb.po_qty as poQty,pb.bom_qty as bomQty,pb.consumption,pb.wastage,pb.moq,b.description,b.im_code as imCode,
            b.use,pb.ip_uom as uom,d.style_number as styleNumber,d.color_desc as color,d.destination_country as destination,d.geo_code as geoCode,d.plant,
            d.planning_season_code as season,d.planning_season_year as year,d.size_description as size,SUBSTRING(d.bom_item, 1, 4) as itemNo,
            b.item_id as itemId,d.po_number as poNumber,d.gender_age_desc as gender, SUBSTRING(d.ogac, 1, 7) as ogacDate,
            TRIM(LEADING '0' FROM d.ship_to_customer_no) as shipToNumber, b.sequence,d.po_and_line as poAndLine,pb.dpom_id as dpomId,d.product_name as productName`)
            .leftJoin(PPMDataEntity, 'd', 'd.id = pb.dpom_id')
            .leftJoin(BomEntity, 'b', 'b.id = pb.bom_id and pb.bom_id is not null')
            .where(`d.po_and_line IN (:...poLine)`, { poLine: req.poLine })
            .andWhere(`b.item_id IN (:...itemId)`, { itemId: req.itemId })
            .andWhere(`pb.bom_id is not null`)
            .andWhere(`d.file_id = ${req.fileId}`)
            .orderBy(`b.sequence`)

        const rawData = await query.getRawMany()
        const mappedData: BomProposalDataModel[] = rawData.map(item => {
            return new BomProposalDataModel({
                id: item.id,
                poQty: item.poQty,
                bomQty: item.bomQty,
                consumption: item.consumption,
                wastage: item.wastage,
                moq: item.moq,
                description: item.description,
                imCode: item.imCode,
                use: item.use,
                styleNumber: item.styleNumber,
                color: item.color,
                destination: item.destination,
                geoCode: item.geoCode,
                plant: item.plant,
                season: item.season,
                year: item.year,
                size: item.size,
                itemColor: item.itemColor,
                itemNo: item.itemNo,
                itemId: item.itemId,
                gender: item.gender,
                poNumber: item.poNumber,
                ogacDate: item.ogacDate,
                shipToNumber: item.shipToNumber,
                attribute: item.attribute,
                attributeValue: item.attributeValue,
                sequence: item.sequence,
                uom: item.uom,
                combination: item.combination,
                poAndLine: item.poAndLine,
                dpomId: item.dpomId,
                productName: item.productName
            });
        });

        return mappedData;
    }

    async getStylesForSelectedPos(req: any) {
        const items = req.items
        const itemsString = items.map(item => `'${item}'`).join(',');
        const query = `SELECT s.style FROM ppm_data d
        LEFT JOIN styles s ON s.style = d.style_number AND s.season = d.planning_season_code and s.year = d.planning_season_year
        INNER JOIN bom b ON b.style_id = s.id AND b.item_id = ${req.itemId}
        WHERE d.bom_item IN (${itemsString}) GROUP BY s.style`
        const res = await this.query(query)
        return res
    }

    async getItemsForSelectedPos(req: any) {
        const items = req.items
        const itemsString = items.map(item => `'${item}'`).join(',');
        const query = `SELECT d.bom_item as itemNo,b.use FROM ppm_data d
        LEFT JOIN styles s ON s.style = d.style_number AND s.season = d.planning_season_code and s.year = d.planning_season_year
        INNER JOIN bom b ON b.style_id = s.id AND b.item_id = ${req.itemId}
        WHERE d.bom_item IN (${itemsString}) GROUP BY d.bom_item,b.use`
        const res = await this.query(query)
        return res
    }

    async getItemsForNecktapeConsumption(req: any) {
        const items = req.items
        const itemsString = items.map(item => `'${item}'`).join(',');
        const query = `SELECT d.bom_item as itemNo,b.use,s.style,b.id FROM ppm_data d
        LEFT JOIN styles s ON s.style = d.style_number AND s.season = d.planning_season_code and s.year = d.planning_season_year
        INNER JOIN bom b ON b.style_id = s.id AND b.item_id = ${req.itemId}
        WHERE d.bom_item IN (${itemsString})  GROUP BY d.bom_item,b.use`
        const res = await this.query(query)
        return res
    }

    

}
